import { gql } from '../__generated__';

export const DELETE_COMPANY_RECOMMENDATION_MUTATION = gql(`
  mutation xcpDeleteCompanyRecommendation($companyId: ID!) {
    deleteCompanyRecommendation(input: { companyId: $companyId }) {
      error {
        message
      }
    }
  }
`);
